export const THEME_COLORS = {
  'primary-100': '#EBFAFA',
  'primary-200': '#CAEDED',
  'primary-300': '#82CECE',
  'primary-400': '#007071',
  'primary-500': '#02595A',
  'primary-600': '#153D3D',

  'secondary-100': '#F0FAEB',
  'secondary-200': '#D1EAC2',
  'secondary-300': '#B2DC99',
  'secondary-400': '#72BF44',
  'secondary-500': '#457628',
  'secondary-600': '#2D4C1A',

  'tertiary-100': '#F0F4F4',
  'tertiary-200': '#E2E9E9',
  'tertiary-300': '#C5D3D3',
  'tertiary-400': '#A8BDBD',
  'tertiary-500': '#6C9393',
  'tertiary-600': '#476B6B',

  'success-100': '#E1EEDA',
  'success-200': '#A4CD8F',
  'success-300': '#86BC69',
  'success-400': '#68AB44',
  'success-500': '#538936',
  'success-600': '#3E6729',

  'error-100': '#F6D8D5',
  'error-200': '#E58980',
  'error-300': '#DD6255',
  'error-400': '#D43B2B',
  'error-500': '#AA2F22',
  'error-600': '#7F231A',

  'caution-100': '#F9DAB3',
  'caution-200': '#F7C78C',
  'caution-300': '#F4B566',
  'caution-400': '#F1A240',
  'caution-500': '#C38333',
  'caution-600': '#946327',

  'gray-100': '#EBEAEB',
  'gray-200': '#C2C1C3',
  'gray-300': '#ADADAF',
  'gray-400': '#575756',
  'gray-500': '#7C7B7D',
  'gray-600': '#5E5E5F',

  'accent-100': '#EFF2F4',
  'accent-200': '#D2DAE0',
  'accent-300': '#B3C2CB',
  'accent-400': '#95AAB6',
  'accent-500': '#5E7888',
  'accent-600': '#495D6A',

  'info-100': '#D6E3F1',
  'info-200': '#83AAD4',
  'info-300': '#5A8EC5',
  'info-400': '#3172B7',
  'info-500': '#275B92',
  'info-600': '#1D446E',

  white: '#ffffff',
  black: '#000000',
};
